<template>
  <div>
    <b-icon icon="trash-fill" type="border" size="medium" variant="danger"  v-b-tooltip.hover.bottom="'Sil'" @click="showDeleteConfirmation" />
    <vs-prompt
    color="danger"
      title=""
      acceptText="Evet"
      cancelText="Vazgeç"
      @accept="kargoGonderiKayitSil"
      @cancel="cancelDelete"
      :active.sync="deleteConfirmationVisible"

    >
      <div class="con-exemple-prompt"  >
        <span>Silmek istediğinize emin misiniz?</span>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import Store from "../../../../store/store";
import state from "../../../../store/state";
import vSelect from "vue-select";
import moment from "moment";

export default {
  data() {
    return {
      kargoGonderiTutanakListe: [
        { id: 1, isDeleted: false, /* Diğer özellikler */ },
        { id: 2, isDeleted: false, /* Diğer özellikler */ },
        // Diğer satırlar
      ],
      plas: "",
      params: { data: { Id: 0 } },
      deleteConfirmationVisible: false, // Silme onay alertinin görünürlüğü
      confirmDelete: false, // Add a flag for confirmation
    };
  },
  created() {
    this.plas = Store.state.plasiyer;
  },
  components: {
    "v-select": vSelect,
  },
  methods: {
    async showDeleteConfirmation() {
      // Silme onay alertini göster
      this.deleteConfirmationVisible = true;
      this.confirmDelete = false; // Reset the flag
    },
    kargoGonderiKayitSil() {
        const vm = this;
        const soap = require("soap");
        const url = state.sistemAddress;
        const args = {
          id: vm.params.data.Id,
        };

        soap.createClient(url, function (err, client) {
          client.kargoGonderiKayitSil(args, function (error, result) {
            if (error) {
              console.error("Silme işlemi sırasında hata oluştu:", error);
              return;
            }
            vm.$root.$emit('kargoGorevListe');
          });
        });

        this.deleteConfirmationVisible = false;
      
    },
    cancelDelete() {
      this.deleteConfirmationVisible = false;
    },

  },
  beforeMount() {
    // ...
  },
};
</script>

<style>


.confirmation-box {
  background-color: #fff;
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 5px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  z-index: 9999;
}

.cancel-button,
.confirm-button {
  background-color: #ccc;
  color: #fff;
  border: none;
  padding: 5px 10px;
  margin: 5px;
  cursor: pointer;
  border-radius: 5px;
}

.confirm-button {
  background-color: #d9534f;
}

.custom-danger-button {
  background-color: #d9534f; /* Set the custom button to the "danger" style */
  color: #fff;
  border: none;
  padding: 5px 10px;
  margin: 5px;
  cursor: pointer;
  border-radius: 5px;
}
</style>
